export interface RuleCategory {
  title: string
  icon: string
  rules: string[]
}

/**
 * Minecraft-specific server rules ONLY. The universal Uliunai code of conduct
 * (Be Respectful / Fair Play / Keep Chat Clean) is owned by the hub
 * (uliunai.com/#conduct) and must NOT be duplicated here — every entry below is
 * a Minecraft-specific mechanic, exploit, punishment or operational policy.
 */
export const rules: RuleCategory[] = [
  {
    title: 'Cheating & Mods',
    icon: 'shield',
    rules: [
      'No x-ray, hacked clients, fly, kill-aura or any combat/movement cheats.',
      'No duplication glitches or item dupes — report the bug instead of abusing it.',
      'Only approved client-side performance and quality-of-life mods are allowed (e.g. Sodium); no radar/cave-finder or cheat mods.',
      'No AFK pools, auto-clickers, macros or machines that farm or bypass server limits while you are away.',
    ],
  },
  {
    title: 'Builds, Land & Griefing',
    icon: 'home',
    rules: [
      'No griefing, stealing from, or destroying other players’ builds or chests.',
      'Claim and protect your land with the protection tool the server provides.',
      'Ask before building close to someone else’s base, and leave reasonable space.',
      'No lava, fire or TNT griefing near other players’ property.',
      'Public and community projects are shared — don’t hoard, vandalise or pave over them.',
    ],
  },
  {
    title: 'World & Server Health',
    icon: 'gauge',
    rules: [
      'No lag machines — keep redstone clocks, mob farms and entity stacks within reasonable limits.',
      'No intentionally lagging or crashing the server, and no exploiting performance bugs.',
      'Staff may ask you to switch off or downsize a build that is hurting server performance.',
    ],
  },
  {
    title: 'PvP & Player Safety',
    icon: 'sword',
    rules: [
      'PvP only by mutual agreement or in designated PvP areas.',
      'No trapping, kill-boxing, or luring players into death traps.',
      'No stealing a player’s items on death where protections are meant to apply.',
    ],
  },
]

export default rules
